exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.copay-epa-source-pharmacy-setting .id-field {\n  width: 300px;\n}\n.copay-epa-source-pharmacy-setting .parser-field {\n  width: 400px;\n}\n.copay-epa-source-pharmacy-setting .action-field {\n  width: 150px;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/components/VCopayEPAPharmacySettings.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;EACE,aAAa;CACd;AACD;EACE,aAAa;CACd","file":"VCopayEPAPharmacySettings.vue","sourcesContent":["\n.copay-epa-source-pharmacy-setting .id-field {\n  width: 300px;\n}\n.copay-epa-source-pharmacy-setting .parser-field {\n  width: 400px;\n}\n.copay-epa-source-pharmacy-setting .action-field {\n  width: 150px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11da8982","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VCopayEPAPharmacySettings.vue
// module id = i0f+
// module chunks = 1